// App
// ----------------------
import React, { useEffect, } from 'react';
// routing
import { Routes, Route, useLocation, } from "react-router-dom";
import { NoMatch } from './router-no-match.js'; // 404 - No Match

// authentication
// auth/ihr-web-sdk
import AuthWrapperIhrWebSdk from './features/auth/ihr-web-sdk/auth-wrapper/auth-wrapper';
// layouts
// Public
import PublicDefaultLayout from './layouts/public/default-layout/default-layout'; // Default Layout
// components
import Homepage from './features/public/homepage/homepage'; // public marketing homepage
// npm
//import ScriptTag from '@gumgum/react-script-tag';
import TagManager from '@sooro-io/react-gtm-module'

// libraries
import 'semantic-ui-less/semantic.less';
// styles
//import './App.css'; //App level css import
//import './App.scss'; //App level scss import
//import stylesCss from './App-css-module.module.css'; //App level-scoped css import
//import stylesScss from './App-scss-module.module.scss'; //App level-scoped scss import

//const REACT_APP_ENV_MODE = process.env.REACT_APP_ENV_MODE;
//console.debug('REACT_APP_ENV_MODE', REACT_APP_ENV_MODE);
const REACT_APP_ANALYTICS_GTM = process.env.REACT_APP_ANALYTICS_GTM;

function App() {

  let location = useLocation();

  useEffect(() => {
    //console.debug('App - location', location);
    // init Google Tag Manager
    if (REACT_APP_ANALYTICS_GTM) {
      const tagManagerArgs = {
        gtmId: REACT_APP_ANALYTICS_GTM,
      };
      TagManager.initialize(tagManagerArgs);
    }
  }, [location]);

  return (
    <div className="App">
      <AuthWrapperIhrWebSdk>
        <Routes>
          <Route path={'/*'} element={<PublicDefaultLayout component={Homepage} />} />
          <Route path="*" element={<NoMatch />} />
        </Routes>
      </AuthWrapperIhrWebSdk>
    </div>
  );
}

export default App;
